import { render, staticRenderFns } from "./request-deadline.modal.vue?vue&type=template&id=36d184a4&scoped=true&"
import script from "./request-deadline.modal.vue?vue&type=script&lang=js&"
export * from "./request-deadline.modal.vue?vue&type=script&lang=js&"
import style0 from "./request-deadline.modal.vue?vue&type=style&index=0&id=36d184a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d184a4",
  null
  
)

export default component.exports